import { Mark, mergeAttributes } from "@tiptap/core";

export interface CitationMarkOptions {
  HTMLAttributes: Record<string, unknown>;
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    citationMark: {
      setCitation: (attrs: { citationId: string; markId: string; locator?: string }) => ReturnType;
      unsetCitation: () => ReturnType;
    };
  }
}

export const CitationMark = Mark.create<CitationMarkOptions>({
  name: "citation",

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      citationId: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-citation-id"),
        renderHTML: (attributes) => {
          if (!attributes.citationId) return {};
          return { "data-citation-id": attributes.citationId };
        },
      },
      markId: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-citation-mark-id"),
        renderHTML: (attributes) => {
          if (!attributes.markId) return {};
          return { "data-citation-mark-id": attributes.markId };
        },
      },
      locator: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-citation-locator"),
        renderHTML: (attributes) => {
          if (!attributes.locator) return {};
          return { "data-citation-locator": attributes.locator };
        },
      },
    };
  },

  parseHTML() {
    return [{ tag: "span[data-citation-id]" }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "span",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
      class: "manuscript-citation",
      style: "color: var(--primary); text-decoration: underline dotted; text-underline-offset: 2px;",
      }),
      0,
    ];
  },

  addCommands() {
    return {
      setCitation:
        (attrs) =>
        ({ commands }) =>
          commands.setMark(this.name, attrs),
      unsetCitation:
        () =>
        ({ commands }) =>
          commands.unsetMark(this.name),
    };
  },
});
